import { Pipe, PipeTransform } from '@angular/core'

import { UtilityService } from '@core/services/utility.service'

@Pipe({
  name: 'dayjsDateTime',
  standalone: false,
})
export class DayjsDateTimePipe implements PipeTransform {
  constructor(private utilityService: UtilityService) {}

  transform(date?: string): string {
    return this.utilityService.dayjsDateTimeFormatting(date)
  }
}
